/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UIConstants from "../../UIConstants";

let waehrung = UIConstants.standardWaehrung;

export function ermittleWaehrung() {
    return waehrung;
}

export function setzeWaehrung(neueWaehrung: string) {
    waehrung = neueWaehrung;
}
